import type { FormState } from '@cast/split-me/components/schedules/ScheduleTabs';
import { toOrdinal } from '@cast/utils';

export const formatTimeZoneDisplayName = (
  timeZoneName: string
): string | undefined =>
  (timeZoneName.split('/').slice(1).join('/') || timeZoneName).replace(
    /_/g,
    ' '
  );

export const formatAt = (formState: FormState): string => {
  switch (formState.type) {
    case 'Week':
      return `${formState.on.join(', ')} at ${formState.at}`;
    case 'Day':
      return formState.at;
    case 'Month':
      return `${formState.onDay
        .map((day) => toOrdinal(Number(day)))
        .join(', ')} at ${formState.at}`;
    case 'Hour':
      return `:${formState.startAtMinute.padStart(2, '0')}`;
    case 'Minute':
      return `From ${formState.startAt}`;
    default:
      return '';
  }
};

export const formatAtLabel = (formState: FormState): string => {
  if (formState.type === 'Hour') return 'Start at minute';
  if (formState.type === 'Minute') return 'Start at';
  return 'At';
};

export const formatFrequency = (formState: FormState): string => {
  const count = formState.repeatEvery ?? 1;
  return `Every ${count} ${formState.type.toLowerCase()}${
    count > 1 ? 's' : ''
  }`;
};
